import { useHistory, useLocation } from 'react-router-dom'
import { AlexiRoutes } from '../../utils/constants/AlexiRoutes.enum'

export function MasterInit() {
  const history = useHistory()
  const location = useLocation()
  
  // Extract the path without the leading slash
  const currentPath = location.pathname.split('/')[1]
  
  // Check if current path is not in AlexiRoutes
  const isInvalidRoute = currentPath && 
    !Object.values(AlexiRoutes).includes(currentPath as AlexiRoutes) &&
    currentPath !== 'application' && 
    currentPath !== 'error'
  
  if (isInvalidRoute) {
    history.push('/application/type')
  }

  return <></>
}
